import http from 'hub-http/clients/apiClient';
const TRIAL_ENDPOINT_BASE = 'trials/v1/trials';
const HUB_TRIAL_ENDPOINT_BASE = 'trials/v1/hub-trials/app';
class TrialsApiSingleton {
  getTrialState() {
    if (this.cachedTrials) {
      return this.cachedTrials;
    }
    this.cachedTrials = http.get(`${HUB_TRIAL_ENDPOINT_BASE}/all`).catch(error => {
      if ((error === null || error === void 0 ? void 0 : error.status) === 0) {
        return [];
      }
      throw error;
    });
    return this.cachedTrials;
  }
  getAvailableTrials() {
    if (this.cachedAvailable) {
      return this.cachedAvailable;
    }
    this.cachedAvailable = http.get(`${TRIAL_ENDPOINT_BASE}/available`).catch(error => {
      if ((error === null || error === void 0 ? void 0 : error.status) === 0) {
        return [];
      }
      throw error;
    });
    return this.cachedAvailable;
  }
  resetTrialState() {
    this.cachedTrials = undefined;
  }
  resetAvailableTrials() {
    this.cachedAvailable = undefined;
  }
}
export const TrialsApi = new TrialsApiSingleton();